module.exports = __webpack_public_path__ + "static/media/08_wage.40645e43.svg";